var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixCalendarV3Participation from '@wix/ambassador-calendar-v3-participation/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Participation is confirmed. */
    Status["CONFIRMED"] = "CONFIRMED";
    /** Participation is pending confirmation. */
    Status["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
})(Status || (Status = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _createParticipationRequest = {};
const _createParticipationResponse = {};
const _deleteParticipationRequest = {};
const _deleteParticipationResponse = {};
const _getParticipationRequest = {};
const _getParticipationResponse = {};
const _queryParticipationsRequest = {};
const _queryParticipationsResponse = {};
const _updateParticipationRequest = {};
const _updateParticipationResponse = {};
/**
 * Retrieves a participation by ID.
 * @param participationId - The participation ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField participationId
 * @adminMethod
 * @returns The participation.
 */
export function getParticipation(participationId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { participationId: '$[0]' };
        const responseTransformation = '$.participation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getParticipationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getParticipationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['participation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([participationId]);
        const reqOpts = ambassadorWixCalendarV3Participation.getParticipation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'participationId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of participations, given the provided filters and paging.
 *
 * Sort: by `createdDate`, default order is `DESC`.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function queryParticipations() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.participations',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryParticipationsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryParticipationsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#participations']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixCalendarV3Participation.queryParticipations(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Creates a schedule or event participation.
 * @param participation - The participation to create.
 * @internal
 * @documentationMaturity preview
 * @requiredField participation
 * @requiredField participation.participant
 * @requiredField participation.participant.name
 * @requiredField participation.partySize
 * @adminMethod
 * @returns The created participation.
 */
export function createParticipation(participation, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            participation: '$[0]',
            idempotencyKey: '$[1].idempotencyKey',
        };
        const responseTransformation = '$.participation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createParticipationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['participation']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createParticipationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['participation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([participation, options]);
        const reqOpts = ambassadorWixCalendarV3Participation.createParticipation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'participation',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a participation.
 * @param _id - The participation ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField participation
 * @requiredField participation.revision
 * @adminMethod
 * @returns The updated participation.
 */
export function updateParticipation(_id, participation, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            participation: { '*': '$[1]', id: '$[0]' },
            fieldmask: '$[2].fieldmask',
        };
        const responseTransformation = '$.participation';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateParticipationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['participation']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateParticipationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['participation']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, participation, options]);
        const reqOpts = ambassadorWixCalendarV3Participation.updateParticipation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'participation',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a participation.
 * @param participationId - The ID of participation to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField participationId
 * @adminMethod
 */
export function deleteParticipation(participationId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { participationId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteParticipationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteParticipationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([participationId]);
        const reqOpts = ambassadorWixCalendarV3Participation.deleteParticipation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'participationId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=calendar-v3-participation.universal.js.map